



















import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';
import { ValidationProvider } from 'vee-validate';
import { PropType } from 'vue';
import { ValidatorProps } from 'types/validator';

export default mixins(E2EMixin).extend({
  name: 'PFileSelector',
  components: {
    ValidationProvider,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: [Object, File],
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Object as PropType<ValidatorProps>,
      default: () => ({ name: undefined, rules: undefined }),
    },
  },
  methods: {
    handleChange(e) {
      // this will update v-model value
      this.$emit('input', e.target.files[0]);
    },
  },
});
